import React from 'react';

const SvgPushNotification = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M7 1a2 2 0 00-2 2v18a2 2 0 002 2h10a2 2 0 002-2v-3h-2v2H7V4h10v2h2V3a2 2 0 00-2-2H7zm8 7c-1.1 0-2 .9-2 2v8l2-2h6c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2h-6z" />
  </svg>
);

export default SvgPushNotification;
